module.exports = "https://cdn.realtymogul.com/static/media/Img_card_PP.1ce962be.jpg";